import { Navigate, Route, Routes } from 'react-router-dom';
import { Content, Header } from '../common/components';
import { isDemo } from '../common/constants/common';
import routes from '../common/constants/routes';
import { t } from '../common/i18n';
import OrderForm from './OrderForm';
import OrderStatus from './OrderStatus';

/**
 * Objednávka služeb (licence / jednorázová hlasování): formulář + stav objednávky.
 * Route je v App.tsx registrovaná jako `/subscription/*` pod AdminRoute.
 */
export const Subscription: React.FC = () => {
  // demo = ukázkový dům, objednat v něm nejde — platí pro všechny vstupy (karta, sidebar, paywall, přímá URL)
  if (isDemo) {
    return (
      <>
        <Header title={t('title', 'Subscription')} customBacklink={routes.building} />
        <Content isEmpty isEmptyText={t('App.demoAvailability')} />
      </>
    );
  }

  return (
    <Routes>
      <Route index element={<OrderForm />} />
      <Route path="order/:orderId" element={<OrderStatus />} />
      <Route path="*" element={<Navigate to={routes.subscriptionOrder} replace />} />
    </Routes>
  );
};

export default Subscription;
